import { styled, ToggleButton, useMediaQuery } from "@mui/material";

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => {
  const mobile = useMediaQuery('(max-width:720px)');
  return {
    "&.MuiToggleButton-root": {
      border: "3px solid #C6CDE0 !important",
      borderRadius: "10px !important",
      textTransform: "lowercase",
      display: "block",
      padding: mobile ? "10px 16px":"14px 18px",
      textAlign: "start",
      marginRight: mobile ? "25px" : "44px",
      "&:not(:first-of-type)": {
        borderRadius: theme.shape.borderRadius,
      },
    },
    "&.Mui-selected": {
      border: "3px solid #B5CAFC !important",
      backgroundColor: "transparent !important",
      boxShadow: "0px 1px 1px 4px rgba(181,202,252,0.8)",
      "&::before": {
        content: "url('https://i.ibb.co/vD75WSJ/Group-861.png')",
        position: "absolute",
        right: "0",
        top: "0",
        marginTop: "-18px",
        marginRight: "-20px",
      },
    },
  };
});
// const ToggleButton = () => {
//     return (
//         <div>

//         </div>
//     );
// };

// export default ToggleButton;
